import React, { useEffect, useState } from "react";
import "./UserManagement.css";
import OverviewCard from "../../components/OverView-Card/overview-card";
import RegistrationTable from "../../components/Registration-table/registration-table";
import PopularBond from "../../components/Popular-bond/Popular-bond";
import RegistartionDetail from "../../components/Registration-details/Registartion-detail";
import RegistartionTableWealth from "../../components/Registration-table-wealth";
import { useNavigate, useNavigation } from "react-router-dom";
import SelectButton from "../../components/SelectButton";
import download from "../../assets/clarity_download-line.png";
import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import ReactTable from "../../components/ReactTable";
import eye from "../../assets/eye.png";
import editBond from "../../assets/editBond.png";
import CustomPagination from "../../components/CustomPagination";
import axios from "axios";
import ReusableModal from "../../components/ReusableModal";
import ToggleButton from "./Toggle";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { BiTransferAlt } from "react-icons/bi";
import { IoClose } from "react-icons/io5";
import { FiCheck } from "react-icons/fi";
import { HiOutlineEye } from "react-icons/hi2";
import CounterOfferModal from "./CounterOfferModal";
import BondViewModal from "./BondViewModal";
import RejectRequestModal from "./RejectSellRequest";
import ApproveSellRequestModal from "./ApproveSellRequest";

export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

const toastIds = {
  roleSuccess: "role-success-toast",
  roleError: "role-error-toast",
  statusSuccess: "status-success-toast",
  statusError: "status-error-toast",
};

function SellRequestMain() {
  const navigate = useNavigate();

  const [searchInputApi, setSearchInputApi] = useState("");
  const [hostedBondData, setHostedBondData] = useState([]);
  const [unhostedBondData, setUnHostedBondData] = useState([]);
  // const [page, setPage] = useState(1);
  const [page, setPage] = useState(1);
  const [unHostedpage, setUnhostedPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [unHostedtotal, setUnhostedTotal] = useState(0);
  const [pageSize, setPazeSize] = useState(0);
  const [unHostedpageSize, setUnHostedPazeSize] = useState(0);

  const { userPermissionData } = useSelector((state) => state.userPermission);

  const [error, setError] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);
  const [newRole, setNewRole] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [managerData, setManagerData] = useState({
    name: "",
    email: "",
    mobileNumber: "",
  });

  const [showCounterOfferModal, setShowCounterOfferModal] = useState(false);
  const [bondViewModal, setBondViewModal] = useState(false);
  const [bondListType, setBondListType] = useState("hosted");
  const [rejectModalOpen, setRejectModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [individualBondData, setIndividualBondData] = useState(null);
  const [remark, setRemark] = useState("");

  const [editRole, setEditRole] = useState({
    id: "",
    name: "",
  });

  const columnHelper = createColumnHelper();

  const fetchHostedBondList = async () => {
    const endpoint = `${base_url}/${api_type}/sellRequest/hosted`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },

        params: {
          page: page,
          search: searchInputApi,
        },
      });
      console.log("sellRequest/hosted response", response);
      setHostedBondData(response?.data?.data?.requestList);
      console.log("total page", response?.data?.data?.totalPages);
      setPage(response?.data?.data?.currentPage);
      setTotal(response?.data?.data?.totalRecords);
      setPazeSize(response?.data?.data?.totalPages); // Adjust according to your API response structure
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  const fetchUnHostedBondList = async () => {
    const endpoint = `${base_url}/${api_type}/sellRequest/unhosted`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },

        params: {
          page: page,
          search: searchInputApi,
        },
      });
      console.log("sellRequest/setUnHostedBondData response", response);
      setUnHostedBondData(response?.data?.data?.requestList);
      console.log("total page", response?.data?.data?.totalPages);
      setUnhostedPage(response?.data?.data?.currentPage);
      setUnhostedTotal(response?.data?.data?.totalRecords);
      setUnHostedPazeSize(response?.data?.data?.totalPages); // Adjust according to your API response structure
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  const handlehostedRequest = async (status) => {
    if (status === "reject" && !remark) return toast.info("Please add remark");
    const endpoint = `${base_url}/${api_type}/sellRequest/hosted/status/${individualBondData?.original?.id}`;

    try {
      const response = await axios.put(
        endpoint,
        {
          status: status,
          remarks: remark,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
          },
        }
      );
      if (status === "reject") {
        toast.success("Sell Request rejected");
        setRemark("");

        setRejectModal(false);
      }
      if (status === "approve") {
        setApproveModal(false);
        toast.success("Sell Request approved");
      }
      setIndividualBondData(null);
      fetchHostedBondList();

      console.log("response handle hosted request reject or approve", response);
    } catch (err) {
      console.error("Error:", err);
      toast.error(err?.response?.data?.message);
    }
  };
  const handleUnhostedRequest = async (status) => {
    if (status === "reject" && !remark) return toast.info("Please add remark");

    const endpoint = `${base_url}/${api_type}/sellRequest/unhosted/status/${individualBondData?.original?.id}`;

    try {
      const response = await axios.put(
        endpoint,
        {
          status: status,
          remarks: remark,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
          },
        }
      );
      if (status === "reject") {
        toast.success("Sell Request rejected");
        setRemark("");

        setRejectModal(false);
      }
      if (status === "approve") {
        setApproveModal(false);
        toast.success("Sell Request approved");
      }
      setIndividualBondData(null);
      fetchUnHostedBondList();
    } catch (err) {
      toast.error(err?.response?.data?.message);

      console.error("Error:", err);
    }
  };

  useEffect(() => {
    if (page) {
      fetchHostedBondList();
    }
    if (unHostedpage) {
      fetchUnHostedBondList();
    }
  }, [page, unHostedpage]);

  const openModal = () => setIsModalOpen(true); // Function to open modal
  const closeModal = () => {
    setIsModalOpen(false);
    setNewRole(""); // Clear the input field when modal is closed
  };
  const closeModalEdit = () => setIsModalOpenEdit(false); // Function to close modal

  const toggleStatus = async (id) => {
    const endpoint = `${base_url}/${api_type}/roles/${id}/toggle`;

    try {
      const response = await axios.put(
        endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!toast.isActive(toastIds.statusSuccess)) {
        toast.success("Status Updated", {
          toastId: toastIds.statusSuccess,
          autoClose: 3000,
        });
      }
      fetchHostedBondList();
    } catch (err) {
      if (!toast.isActive(toastIds.statusError)) {
        toast.error(err?.response?.data.message || "Failed to update status", {
          toastId: toastIds.statusError,
          autoClose: 3000,
        });
      }
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };

  const handleSellRequest = (data, type) => {
    setIndividualBondData(data);
    console.log("handleSellRequest clicked");
    if (type === "reject") {
      setRejectModal(true);
      console.log("handle sell request reject data ", data);
    }
    if (type === "approve") {
      setApproveModal(true);
      console.log("handle sell request approve data ", data);
    }
  };

  const hostedcolumns = [
    columnHelper.accessor((row) => row.user.name, {
      id: "userName", // Give it a unique ID if you're using a function accessor
      cell: (info) => info.renderValue(),
      header: () => <span>Seller Name</span>,
    }),
    columnHelper.accessor("bondName", {
      cell: (info) => info.renderValue(),
      header: () => <span>Bond Name</span>,
    }),
    columnHelper.accessor("isin", {
      cell: (info) => info.renderValue(),
      header: () => <span>ISIN</span>,
    }),
    columnHelper.accessor("quantity", {
      cell: (info) => info.renderValue(),
      header: () => <span>Units</span>,
    }),
    columnHelper.accessor("rate", {
      cell: (info) => info.renderValue(),
      header: () => <span>Price</span>,
    }),
    columnHelper.accessor("marketRate", {
      cell: (info) => info.renderValue(),
      header: () => <span className=""> Market Price</span>,
    }),

    columnHelper.accessor((row) => row, {
      id: "action",
      cell: (info) => {
        const uniqueId = info?.row?.original?.id;
        const name = info?.row?.original?.name;
        console.log("investorid", uniqueId);

        return (
          <>
            {userPermissionData?.user?.edit && (
              <div className="flex flex-start gap-5">
                {/* <span className="w-[32px] h-[30px] bg-[#DFEEF8] flex items-center justify-center cursor-pointer">
                  <HiOutlineEye
                    onClick={() => setBondViewModal(!bondViewModal)}
                    size={20}
                    color="#035C98"
                  />
                </span>
                <span className="w-[32px] h-[30px] bg-[#FAE2C8] flex items-center justify-center cursor-pointer">
                  <BiTransferAlt
                    size={20}
                    color="#B4620A"
                    onClick={() =>
                      setShowCounterOfferModal(!showCounterOfferModal)
                    }
                  />
                </span> */}
                <span
                  onClick={(e) => {
                    e.stopPropagation();

                    handleSellRequest(info?.row, "reject");
                  }}
                  className="w-[32px] h-[30px] bg-[#FFEBEB] flex items-center justify-center cursor-pointer"
                >
                  <IoClose size={20} color="#DD0000" />
                </span>
                <span
                  onClick={() => handleSellRequest(info?.row, "approve")}
                  className="w-[32px] h-[30px] bg-[#289A3F] flex items-center justify-center cursor-pointer"
                >
                  <FiCheck size={20} color="#FFFFFF" />
                </span>
              </div>
            )}
          </>
        );
      },
      header: () => <span>Action</span>,
    }),
  ];
  const unHostedcolumns = [
    columnHelper.accessor((row) => row.user.name, {
      id: "userName", // Give it a unique ID if you're using a function accessor
      cell: (info) => info.renderValue(),
      header: () => <span>Seller Name</span>,
    }),
    columnHelper.accessor("bondName", {
      cell: (info) => info.renderValue(),
      header: () => <span>Bond Name</span>,
    }),
    columnHelper.accessor("isin", {
      cell: (info) => info.renderValue(),
      header: () => <span>ISIN</span>,
    }),
    columnHelper.accessor("quantity", {
      cell: (info) => info.renderValue(),
      header: () => <span>Units</span>,
    }),
    columnHelper.accessor("rate", {
      cell: (info) => info.renderValue(),
      header: () => <span>Price</span>,
    }),
    columnHelper.accessor("marketRate", {
      cell: (info) => info.renderValue(),
      header: () => <span className=""> Market Price</span>,
    }),

    columnHelper.accessor((row) => row, {
      id: "action",
      cell: (info) => {
        const uniqueId = info?.row?.original?.id;
        const name = info?.row?.original?.name;
        console.log("investorid", uniqueId);

        return (
          <>
            {userPermissionData?.user?.edit && (
              <div className="flex flex-start gap-5">
                {/* <span className="w-[32px] h-[30px] bg-[#DFEEF8] flex items-center justify-center cursor-pointer">
                  <HiOutlineEye
                    onClick={() => setBondViewModal(!bondViewModal)}
                    size={20}
                    color="#035C98"
                  />
                </span>
                <span className="w-[32px] h-[30px] bg-[#FAE2C8] flex items-center justify-center cursor-pointer">
                  <BiTransferAlt
                    size={20}
                    color="#B4620A"
                    onClick={() =>
                      setShowCounterOfferModal(!showCounterOfferModal)
                    }
                  />
                </span> */}
                <span className="w-[32px] h-[30px] bg-[#FFEBEB] flex items-center justify-center cursor-pointer">
                  <IoClose
                    onClick={() => handleSellRequest(info?.row, "reject")}
                    size={20}
                    color="#DD0000"
                  />
                </span>
                <span className="w-[32px] h-[30px] bg-[#289A3F] flex items-center justify-center cursor-pointer">
                  <FiCheck
                    onClick={() => handleSellRequest(info?.row, "approve")}
                    size={20}
                    color="#FFFFFF"
                  />
                </span>
              </div>
            )}
          </>
        );
      },
      header: () => <span>Action</span>,
    }),
  ];

  return (
    <div className=" mt-[60px] px-4 flex flex-col min-h-[calc(100vh-100px)]">
      <div className=" px-8 py-2  mt-4   overflow-auto">
        <span
          className={`text-[#035C98] ml-5 px-8 py-2 text-lg cursor-pointer ${
            bondListType === "hosted" && `border-b-4 border-[#035C98]`
          }  font-poppins font-bold`}
          onClick={() => setBondListType("hosted")}
        >
          Hosted Bond{" "}
        </span>
        <span
          onClick={() => setBondListType("unhosted")}
          className={`text-[#035C98] ml-5 px-8 py-2 cursor-pointer text-lg ${
            bondListType === "unhosted" && `border-b-4 border-[#035C98]`
          }  font-poppins font-bold`}
        >
          Un-Hosted Bond{" "}
        </span>
      </div>

      <div className="w-full font-poppins mt-3 rounded-[10px] border-t pt-4 bg-white">
        {bondListType === "hosted" && (
          <ReactTable
            key={JSON?.stringify(hostedBondData)}
            defaultData={hostedBondData}
            columns={hostedcolumns}
          />
        )}
        {bondListType === "unhosted" && (
          <ReactTable
            key={JSON?.stringify(unhostedBondData)}
            defaultData={unhostedBondData}
            columns={unHostedcolumns}
          />
        )}
      </div>

      {hostedBondData?.length > 0 && bondListType === "hosted" && (
        <div className="w-auto mt-auto border-t">
          <CustomPagination
            currentPage={page}
            setCurrentPage={setPage}
            totalItems={total}
            itemsPerPage={10}
            maxPageNumbersToShow={5}
            storageKey=""
          />
        </div>
      )}
      {unhostedBondData?.length > 0 && bondListType === "unhosted" && (
        <div className="w-auto mt-auto border-t">
          <CustomPagination
            currentPage={unHostedpage}
            setCurrentPage={setUnhostedPage}
            totalItems={unHostedtotal}
            itemsPerPage={10}
            maxPageNumbersToShow={5}
            storageKey=""
          />
        </div>
      )}
      {showCounterOfferModal && (
        <CounterOfferModal
          showCounterOfferModal={showCounterOfferModal}
          setShowCounterOfferModal={setShowCounterOfferModal}
        />
      )}
      {rejectModalOpen && (
        <RejectRequestModal
          isOpen={rejectModalOpen}
          onClose={() => setRejectModal(false)}
          individualBondData={individualBondData}
          remark={remark}
          setRemark={setRemark}
          onContinue={
            bondListType === "hosted"
              ? handlehostedRequest
              : handleUnhostedRequest
          }
        />
      )}
      {approveModal && (
        <ApproveSellRequestModal
          isOpen={approveModal}
          onClose={() => setApproveModal(false)}
          individualBondData={individualBondData}
          onContinue={
            bondListType === "hosted"
              ? handlehostedRequest
              : handleUnhostedRequest
          }
        />
      )}
      {bondViewModal && (
        <BondViewModal
          bondViewModal={bondViewModal}
          setBondViewModal={setBondViewModal}
        />
      )}
    </div>
  );
}

export default SellRequestMain;
